export enum DataType {
    DATE = 'date',
    STRING = 'string',
    NUMBER = 'number'
}
